import { BehaviorSubject, distinctUntilChanged, map } from "rxjs";

let storedToken = null;
let storedRefreshToken = null;
let storedEmail = null;
let storedUserId = null;
if (typeof window !== "undefined") {
  storedToken = localStorage?.getItem("accessToken") || "";
  storedRefreshToken = localStorage?.getItem("refreshToken") || "";
  storedEmail = localStorage?.getItem("email") || "";
  storedUserId = localStorage?.getItem("userId") || "";
}

interface AuthState {
  accessToken: string | null;
  refreshToken: string | null;
  email: string | null;
  userId: string | null;
}

const authState = new BehaviorSubject<AuthState>({
  accessToken: storedToken,
  refreshToken: storedRefreshToken,
  email: storedEmail,
  userId: storedUserId,
});

export const authService = {
  accessToken: authState.asObservable().pipe(
    map((s) => s.accessToken),
    distinctUntilChanged()
  ),
  get accessTokenValue() {
    return authState.value.accessToken;
  },
  set accessTokenValue(accessToken: string | null) {
    authState.next({ ...authState.value, accessToken });
    if (typeof window !== "undefined") {
      localStorage?.setItem("accessToken", accessToken ?? "");
    }
  },
  get refreshTokenValue() {
    return authState.value.refreshToken;
  },
  set refreshTokenValue(refreshToken: string | null) {
    authState.next({ ...authState.value, refreshToken });
    if (typeof window !== "undefined") {
      localStorage?.setItem("refreshToken", refreshToken ?? "");
    }
  },
  get emailValue() {
    return authState.value.email;
  },
  set emailValue(email: string | null) {
    authState.next({ ...authState.value, email });
    if (typeof window !== "undefined") {
      localStorage?.setItem("email", email ?? "");
    }
  },
  get userIdValue() {
    return authState.value.userId;
  },
  set userIdValue(userId: string | null) {
    authState.next({ ...authState.value, userId });
    if (typeof window !== "undefined") {
      localStorage?.setItem("userId", userId ?? "");
    }
  },
  logout: () => {
    if (typeof window !== "undefined") {
      localStorage?.removeItem("accessToken");
      localStorage?.removeItem("refreshToken");
      localStorage?.removeItem("email");
      localStorage?.removeItem("userId");
    }
  },
};
